import { render, staticRenderFns } from "./vpbank.vue?vue&type=template&id=53d3d9ae&scoped=true&"
import script from "./vpbank.vue?vue&type=script&lang=js&"
export * from "./vpbank.vue?vue&type=script&lang=js&"
import style0 from "./vpbank.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./vpbank.vue?vue&type=style&index=1&id=53d3d9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3d9ae",
  null
  
)

export default component.exports